//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Sswiper, { Navigation, Autoplay } from 'swiper'
import mobileTab from '~/components/common/mobileTab.vue'
import lineCharts from '~/components/burstdetails/lineCharts.vue'
import breadCrumbs from '~/components/common/breadCrumbs.vue'
import { matomofn } from '~/assets/js/utils.js'
import 'swiper/swiper-bundle.css'
Sswiper.use([Navigation, Autoplay])
export default {
  components: {
    lineCharts, mobileTab, 'bread-crumbs': breadCrumbs
  },
  async asyncData ({ $api }) {
    try {
      const res = await Promise.all([
        $api.burstData.newBrustDataService({ period: 1 })
      ])
      const [data] = res
      const brustMessage = data?.BrustMessageResponse?.brustMessage
      const brustData = data?.BrustDataResponse?.brustData
      return { brustMessage, brustData }
    } catch (error) {}
  },
  data () {
    return {
      burstSwiper: null,
      isClick: 0, // 防止重复的tab点击
      tabsIndex: 0, // 当前选中的tab下标
      tabsData: [ // tab数据
        {
          name: '15544'
        },
        {
          name: 'TYY_000183'
        },
        {
          name: 'TYY_000182'
        },
        {
          name: 'TYY_000184'
        }
      ],
      pageEnterTime: null // 页面进入时间
    }
  },
  head () {
    return {
      title: this.$t('19816'),
      meta: [
        { name: 'Keywords', content: this.$t('TYY_000667') },
        { name: 'Description', content: this.$t('19817') }
      ]
    }
  },
  beforeDestroy () {
    this?.burstSwiper?.destroy() // 销毁轮播图
    this.burstSwiper = null
    // 移除事件监听器
    window.removeEventListener('beforeunload', this.trackPageTime)
    // 执行页面时间统计
    this.trackPageTime()
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$store?.state?.screenWidth > 799) this.swiperFn()
      else this.swiperFnm()
    })
    // 记录页面进入时间
    this.pageEnterTime = Date.now()
    // 监听页面关闭事件
    window.addEventListener('beforeunload', this.trackPageTime)
  },
  methods: {
    // 页面时间统计
    trackPageTime () {
      if (this.pageEnterTime) {
        const exitTime = Date.now()
        matomofn('Cloud_Stop_Out_Time', {
          af_Enter: this.pageEnterTime,
          af_Exit: exitTime
        }, this.$store.state, this.$cookies)
      }
    },
    mobileTab (item) {
      this.handleClick(item.index)
    },
    // 获取表格数据
    async handleClick (index) {
      if (this.isClick == index) return
      const { BrustDataResponse } = await this.$api.burstData.newBrustDataClient({ period: index + 1 })
      this.brustData = BrustDataResponse.brustData
      this.tabsIndex = index
      this.isClick = index
    },
    // 跳转到详情页
    toDetails (text = '') {
      const currType = (this.tabsIndex + 1)
      const supplement = (currType > 1 ? `?period=${currType}` : '')
      window?.open(`/${this.currLangCode()}/data/burst/${text}.html${supplement}`)
    },
    // 最新爆仓数据轮播图
    swiperFn () {
      const that = this
      this.burstSwiper = new Sswiper('.filmswiper', {
        direction: 'vertical',
        loop: !!this.brustMessage.length,
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        }
      })
      this.burstSwiper.el.onmouseover = function () {
        that.burstSwiper.autoplay.stop()
      }
      this.burstSwiper.el.onmouseout = function () {
        that.burstSwiper.autoplay.start()
      }
    },
    // 最新爆仓数据轮播图手机端
    swiperFnm () {
      const that = this
      this.burstSwiper = new Sswiper('.swiper-container-m', {
        loop: !!this.brustMessage.length,
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        }
      })
      this.burstSwiper.el.onmouseover = function () {
        that.burstSwiper.autoplay.stop()
      }
      this.burstSwiper.el.onmouseout = function () {
        that.burstSwiper.autoplay.start()
      }
    }
  }
}
